import * as React from 'react';
import * as ReactDom from 'react-dom';
import Tooltip from 'rc-tooltip';
import { BaseComponent, BaseComponentProps, BaseComponentState } from './BaseComponent';
import { getMapManager, GmapStateManager } from '../utils/GmapStateManager';
import { isNull } from '../utils/index';
import { HotelBedData, HotelBedCatalogData } from '../shared/index';
import { DefMapCenter } from '../HotelApplication';
import { CategoryHotels } from '../core/CategoryHotels';
import { getHotelSlug, FormatterUtils, LOCAL_STORAGE_KEY_WISHLIST, BHAM_STORAGE_WISHLIST } from '../core/Const';
import { WishlistRequest } from './../hotels/HotelListPanel';
import { WishlistStorageData } from '../header/WishList';
import { getAjaxhelper } from '../utils/CoreAjaxHelper';
import AsyncSelect from 'react-select/lib/Async';
import * as Slider from 'rc-slider'; 

// var google: any;
const Range: any = Slider.Range as any;
const Handle = Slider.Handle;
const handle = (props: any) => {
    const { value, dragging, index, ...restProps } = props;
    return (
        <Tooltip
            overlay={value}
            visible={dragging}
            placement="top"
            key={index}
        >
            <Handle value={value} {...restProps} />
        </Tooltip>
    );
};
export interface ListGmapLiftProps extends BaseComponentProps {
    data: HotelBedData.Hotel;
    idx: number;
    responKey: string;
    map: any;
    lastSelectedCode: number;
    gmarkers: any;
    wishlistCount: (id: number) => any;
    initialFilter: HotelBedData.FilterSearch;
    updateLastSelectedCode: (id: number) => any;
    imageHotel: { height: number, width: number, left: number };
    preficId: string;
    reqAvailabilityDetailId: number;
    night: string;
}
export interface ListGmapLiftState extends BaseComponentState {
    wishlistAnimeClass: string;
    btnWishlist: any;
    image_url: string;
}
abstract class ListGmapLift extends BaseComponent<ListGmapLiftProps, ListGmapLiftState> {

    constructor(props: ListGmapLiftProps) {
        super(props);
        this.state = {
            wishlistAnimeClass: 'hide',
            image_url: '',
            btnWishlist: (
                <a
                    onClick={this.wishlishOnclick}
                >
                    <i className="fa fa-heart" style={{ color: 'red' }} /> Wish List
                </a>
            )
        };
    }
    wishlishOnclick: (evt: any) => any = (evt: any) => {
        this.linktoHotelorWishlist(evt, 'wishlist', '', this.props.data);
    }

    wishlist: (hotel: HotelBedData.Hotel ) => any = (hotel: HotelBedData.Hotel) => {
        console.log("Wishlist");
        let a = localStorage.getItem(LOCAL_STORAGE_KEY_WISHLIST);
        let img = hotel.thumb ? hotel.thumb : '';
        let h: HotelBedData.Hotel = {
            code: hotel.code,
            name: hotel.name,
            description: hotel.description,
            zoneName: hotel.zoneName,
            image: img,
            latitude: hotel.latitude,
            longitude: hotel.latitude,
            minRate: hotel.minRate,
            categoryCode: hotel.categoryCode,
            address: hotel.address,
            star: hotel.star
        };
        let dd: string[] = [];
        if ((a)) {
            let data: WishlistStorageData = JSON.parse(a as any);
            dd = JSON.parse(data.rowData);
            
        }  
        dd.push(JSON.stringify(h)); 
        let wishlistID = sessionStorage.getItem(BHAM_STORAGE_WISHLIST) ? sessionStorage.getItem(BHAM_STORAGE_WISHLIST) : null;
        let wishlistRequest: WishlistRequest = {
            filter: JSON.stringify(this.props.initialFilter),
            rowData: JSON.stringify(dd),
            code: wishlistID,
            status: 'OPEN'
        };
        this.setStateHelper(
            st => {
                st.wishlistAnimeClass = 'jantung-terbang';
            },
            () => {
                getAjaxhelper().post("/dynamics/hb-api/cms-wishlist", wishlistRequest).then(d => {
                     
                    localStorage.setItem(LOCAL_STORAGE_KEY_WISHLIST, JSON.stringify(d));
                    sessionStorage.setItem(BHAM_STORAGE_WISHLIST, d.code );
                    this.props.wishlistCount(1);
                    this.setState({ btnWishlist: <span />, wishlistAnimeClass: 'hide' });
                }).catch(exc => {
                    console.log(exc);
                });
            }); 

    }

    linktoHotelorWishlist(evt: any, dari: string, url: string, data: HotelBedData.Hotel) {
        if (dari === 'hotel') {
            window.open(`/${url}?rk=${this.props.responKey}&reqaid=${this.props.reqAvailabilityDetailId}&night=${this.props.night}`, '_blank');
            // window.location.href  = `/${url}?rk=${this.props.responKey}&reqaid=${this.props.reqAvailabilityDetailId}&night=${this.props.night}`;
            window.focus();
            // document.URL()
        } else if (dari === 'wishlist') {
            evt.stopPropagation();
            this.wishlist(data );
        } else {
            //
        }
    }
    clickHandler: (evt: any) => any =
        (evt: any) => {
            let url = getHotelSlug(this.props.data.name!, this.props.data.code!);
            // 
            this.linktoHotelorWishlist(evt, 'hotel', url, {});
        }
    mouseOver: () => any = () => {
        this.props.map.setZoom(15);
        this.props.map.setCenter(new google.maps.LatLng(this.props.data.latitude!, this.props.data.longitude!));
        google.maps.event.trigger(this.props.gmarkers, "mouseover");
        let lastSelected = document.getElementById(`left${this.props.lastSelectedCode}`);
        if (lastSelected) {
            lastSelected.classList.remove("active");
            this.props.updateLastSelectedCode(this.props.data.code!);
        }
    }

    render() {
        // let url = getHotelSlug(this.props.data.name, this.props.data.code);
        return (
            <div
                id={`${this.props.preficId}${this.props.data.code}`}
                // href={`/${url}?rk=${this.props.responKey}`}
                // target="_blank"
                // className="map-left-panel-list-hotel"
                onMouseOver={this.mouseOver}
                onClick={this.clickHandler}
                className='row map-left-panel-list-hotel'
            >
                <div style={{ backgroundImage: `url("${this.props.data.thumb}")`, backgroundSize: 'cover', height: this.props.imageHotel.height, width: this.props.imageHotel.width, float: 'left' }} />
                <div style={{ marginLeft: this.props.imageHotel.left, marginRight: 20 }}>
                    <span style={{ fontSize: 15 }}>{this.props.data.name} </span> <br />
                    <CategoryHotels
                        star={this.props.data.star!}
                        size="small"
                    />
                    <br />
                    <img src={this.props.data.tripAdvisorRatingImage} width='75' /> <br />
                    <span style={{ fontSize: 15, color: '#ff7a00' }}>start from {new FormatterUtils().formatMoney(this.props.data.minRate!, this.props.data.currency!, true, false)}</span>
                    <br />
                    {this.state.btnWishlist}
                </div>

            </div>
        );
    }

}

export interface BaseGmapPanelProps extends BaseComponentProps {

    /**
     * style untuk div MAP
     */
    style?: React.CSSProperties;
    defMapCenter: DefMapCenter;
    mapZoom: number;
    updateMapCenter: (data: DefMapCenter, mapZoom: number) => any;
    responKey: string;
    currency: string;
    lang: string;
    wishlistCount: (id: number) => any;
    idHotels?: number;
}

export interface BaseGmapPanelState extends BaseComponentState {
    leftSideClassName: 'leftsidegmap' | 'leftsidegmap-hide';
    leftsidegmapmenu: 'leftsidegmapmenu' | 'leftsidegmapmenu-hide';
    topSearchMap: 'topsearch-map' | 'topsearch-map-hide';
    requesting: boolean;
    dataHotels: HotelBedData.Hotel[];
    dataHotelsFiltered: HotelBedData.Hotel[];
    indexedCategoryData: { [id: string]: HotelBedCatalogData.Category };
    version: number;
    selectValue: any;
    selectCreatable: boolean;
    backspaceRemoves: boolean;
    minPrice: number;
    maxPrice: number;
    minRate: number;
    maxRate: number;
    versi: number;
    lastSelectedCode: number;
    wishlistAnimeClass: string;
    initialFilter: HotelBedData.FilterSearch | any;
    indexHotel: { [id: number]: HotelBedData.Hotel };
}
/**
 * base class untuk gmap panel
 */
export abstract class BaseGmapPanel<PROPS extends BaseGmapPanelProps, STATE extends BaseGmapPanelState> extends BaseComponent<PROPS, STATE> {

    mapStateManager: GmapStateManager;
    gmapReference?: google.maps.Map;
    gmarkers: any[] = [];
    prevInfowindow: any = false;
    highestZIndex: number = 0;
    tmpZindexMaker: number = 0;

    /**
     * key dari api yang di pakai
     */
    apiKey: string = 'AIzaSyAwKQXrpCCyjwljuwmbdhvxaeQ5dZi5DF8';

    /**
     * method untuk di trigger pada saat map ready
     */
    mapReadyMethodName: string = 'map_ready_method_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 100);

    /**
     * id panel untuk gmap
     */
    private gmapDivId: string = 'gmap_panel_' + this.props.currency + this.props.lang + new Date().getTime() + '_' + Math.ceil(Math.random() * 100);
    private onMapReadyHandler: any;

    /**
     * reference ke google map
     */

    constructor(props: PROPS) {
        super(props);
        this.mapStateManager = getMapManager(props.currency + props.lang);
        if (this.mapStateManager.mapReady) {
            console.log("wawan");
            let mpOpt: google.maps.MapOptions = this.generateMapOption();
            let targetDiv: HTMLElement | any = document.getElementById(this.gmapDivId);
            this.gmapReference = new google.maps.Map(targetDiv, mpOpt);
            this.onMapRendered(this.gmapReference);
        } else {
            this.onMapReadyHandler = () => {
                this.renderGMAP(this.gmapDivId);
            };
            this.mapStateManager.register(this.onMapReadyHandler);
        }

    }

    renderPopup: (id: number) => any = (id: number) => {
        // alert(`${id}`);
        const t: HTMLElement | any = document.getElementById(`content-${id}`);
        console.log("ID Hotel", id);
        if (t) {
            const panelParam: ListGmapLiftProps = {
                data: this.state.indexHotel[id],
                gmarkers: this.gmarkers,
                idx: id,
                initialFilter: this.state.initialFilter,
                lastSelectedCode: this.state.lastSelectedCode,
                map: this.gmapReference,
                responKey: this.props.responKey,
                updateLastSelectedCode: this.updateLastSelectedCode,
                wishlistCount: this.props.wishlistCount,
                imageHotel: { height: 120, width: 150, left: 160 },
                preficId: 'mapPopoup',
                reqAvailabilityDetailId: this.state.indexHotel[id].reqAvailableDetailId!,
                night: '' // this.state.initialFilter
            };
            console.log("panelParam", panelParam);
            ReactDom.render((<ListGmapLift key={`infoWindow-${id}`} {...panelParam} />), t);
        } else {
            // console.log(`content-${id} Tidak Ketemu`);
            setTimeout(() => this.renderPopup(id), 10);
        }
    }

    gMaker: (dataMapHotel: any, map: any) => any = (dataMapHotel: any, map: any) => {
        for (let d of dataMapHotel) {
            let marker: google.maps.Marker = new google.maps.Marker({
                position: d.cordinat,
                map: map,
                icon: 'https://storage.googleapis.com/bali-hotel-images/Googlemap-pin-blue.png',
                zIndex: this.gmarkers.length + 1
            });
            marker.addListener('mouseover', () => {
                this.setStateHelper(
                    sts => {
                        sts.lastSelectedCode = d.alldata.code;
                    },
                    () => {
                        if (this.prevInfowindow) {
                            this.prevInfowindow.close();
                        }

                        let lastSelected = document.getElementById(`left${this.state.lastSelectedCode}`);
                        if (lastSelected) {
                            lastSelected.classList.remove("active");
                        }
                        let targetNode: any = document.getElementById(`left${d.alldata.code}`);
                        setTimeout(() => { targetNode.focus(); }, 20);

                        targetNode.classList.add("active");

                        var contentString =

                            `<div id="content-${d.alldata.code}">  </div>`;

                        let infowindow: google.maps.InfoWindow = new google.maps.InfoWindow();
                        infowindow.setContent(contentString);
                        infowindow.open(map, marker);

                        this.prevInfowindow = infowindow;
                        this.renderPopup(d.alldata.code);
                    }
                );

            });
            marker.setTitle(d.hotelName);
            this.gmarkers.push(marker);
        }
    }

    onLeftMenuClick: () => any = () => {

        let leftSideClassName: 'leftsidegmap' | 'leftsidegmap-hide' = this.state.leftSideClassName === 'leftsidegmap' ? 'leftsidegmap-hide' : 'leftsidegmap';
        let leftsidegmapmenu: 'leftsidegmapmenu' | 'leftsidegmapmenu-hide' = this.state.leftsidegmapmenu === 'leftsidegmapmenu' ? 'leftsidegmapmenu-hide' : 'leftsidegmapmenu';

        this.setStateHelper(st => {
            st.leftSideClassName = leftSideClassName;
            st.leftsidegmapmenu = leftsidegmapmenu;
        });
    }

    categoryHotels: (data: any) => any = (data: any) => {
        return (
            <CategoryHotels 
                star={data.star}
                size="small"
            />
        );
    }
 
    triggerMouseEvent: (node: any, eventType: any) => any = (node: any, eventType: any) => {
        var clickEvent = document.createEvent('MouseEvents');
        clickEvent.initEvent(eventType, true, true);
        node.dispatchEvent(clickEvent);
    }

    onChange: (value: any) => any = (value: any) => {
        let lastSelected = document.getElementById(`left${this.state.lastSelectedCode}`);
        if (lastSelected) {
            lastSelected.classList.remove("active");
        }
        this.setStateHelper(
            st => {
                st.selectValue = value;
                st.lastSelectedCode = !isNull(value) && !isNull(value.value) && !isNull(value.value.code) ? value.value.code : 0;
            },
            () => {
                console.log("this.state.selectValue", this.state.selectValue);
                if (!isNull(this.state.selectValue) && !isNull(this.state.selectValue.value) && !isNull(this.state.selectValue.value.code)) {

                    let targetNode: any = document.getElementById(`left${this.state.selectValue.value.code}`);
                    // console.log(targetNode);
                    setTimeout(() => { targetNode.focus(); }, 20);
                    this.triggerMouseEvent(targetNode, "mouseover");
                    targetNode.classList.add("active");
                }
            });
    }

    setMapOnAll: (map: google.maps.Map | any) => any = (map: google.maps.Map | any) => {
        for (var i = 0; i < this.gmarkers.length; i++) {
            this.gmarkers[i].setMap(map);
        }
    }

    clearMarkers: () => any = () => {
        this.setMapOnAll(null);
    }

    showMarkers: () => any = () => {
        this.setMapOnAll(this.gmapReference!);
    }

    deleteMarkers: () => any = () => {
        this.clearMarkers();
        this.gmarkers = [];
    }

    filterPrice: () => any = () => {
        let min = this.state.minPrice;
        let max = this.state.maxPrice;
        this.deleteMarkers();
        let htFiltered: HotelBedData.Hotel[] = [];
        for (let ht of this.state.dataHotels) {
            if ((ht.minRate! >= min && ht.minRate! <= max) || (ht.maxRate! >= min && ht.maxRate! <= max)) {
                htFiltered.push(ht);
                // this.gmarkers.push(ht);
            }
        }

        var dataMapHotel = [];

        for (let data of htFiltered) {
            dataMapHotel.push(
                {
                    cordinat: { lat: data.latitude! / 1, lng: data.longitude! / 1 },
                    hotelName: data.name,
                    hotelDesc: data.description,
                    hotelImages: `${data.image}`,
                    slug: getHotelSlug(data.name!, data.code!),
                    tripAdvisorRatingImage: data.tripAdvisorRatingImage,
                    minRate: data.minRate, currency: data.currency,
                    alldata: data,
                    star: data.star
                }
            );
        }
        this.gMaker(dataMapHotel, this.gmapReference);

        this.gmapReference!.setZoom(this.props.mapZoom);
        this.gmapReference!.setCenter(new google.maps.LatLng(this.props.defMapCenter.lat, this.props.defMapCenter.lng));

        this.setStateHelper(
            st => {
                st.dataHotelsFiltered = htFiltered;
            }
        );

        // todo filter price
    }
    updateLastSelectedCode: (id: number) => any = (id: number) => {
        this.setState({ lastSelectedCode: id });
    }
    render(): JSX.Element {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let style: React.CSSProperties | any = !isNull(this.props.style) ? this.props.style : {
            width: '100%',
            height: '500px'
        };
        let leftDataRan: any[] = [];

        // let popup = [];
        if (this.state.requesting === false) {
            let idx = 0;
            for (let ht of this.state.dataHotelsFiltered) {
                leftDataRan.push(<li><ListGmapLift night="" reqAvailabilityDetailId={ht.reqAvailableDetailId!} preficId="left" imageHotel={{ height: 100, width: 100, left: 110 }} updateLastSelectedCode={this.updateLastSelectedCode} initialFilter={this.state.initialFilter} wishlistCount={this.props.wishlistCount} key={`left-side${ht.code}`} data={ht} gmarkers={this.gmarkers[idx]} map={this.gmapReference} idx={idx} responKey={this.props.responKey} lastSelectedCode={this.state.lastSelectedCode} /></li>);
                idx++;
            }
        }
        let handleChange = (value: any) => {
            this.setStateHelper(
                st => {
                    st.minPrice = value[0];
                    st.maxPrice = value[1];
                    st.versi += 1;
                },
                () => this.filterPrice());
        };
        let trigerMin: (evt: any) => any = (evt: any) => {
            let val: any = evt.target.value;
            if (val / 1 !== this.state.minPrice / 1) {
                this.setStateHelper(
                    st => {
                        st.minPrice = val as any / 1;
                    },
                    () => {
                        handleChange([val, this.state.maxPrice]);
                    }
                );
            } else {
                console.log("max rate, min rate", this.state.maxRate, this.state.minRate, this.state.versi + 1);
            }
        };
        let trigetMax: (evt: any) => any = (evt: any) => {
            let val: any = evt.target.value;
            if (val / 1 !== this.state.maxPrice / 1) {
                this.setStateHelper(
                    st => {
                        st.maxPrice = val as any / 1;
                    },
                    () => {
                        handleChange([this.state.minPrice, val]);
                    }
                );
            } else {
                console.log("max rate, min rate", this.state.maxRate, this.state.minRate, this.state.versi + 1);
            }
        };

        // const AsyncComponent = this.state.selectCreatable ? Select.AsyncCreatable : Select.Async;
        let optHolder: any[] = [];
        let hot: HotelBedData.Hotel[] = this.state.dataHotels;
        for (let hotel of hot) {
            optHolder.push({
                'label': hotel.name + ' ' + hotel.zoneName,
                'value': hotel
            });
        }
        const filterColors = (inputValue: string) =>
            optHolder.filter((i: any) =>
                i.label.toLowerCase().includes(inputValue.toLowerCase())
            );
        const loadOptions = (inputValue: string, callback: any) => {
            setTimeout(() => { callback(filterColors(inputValue)); }, 1000);
        };
        const customStyles = {
            option: (base: any, state: any) => ({
                ...base,
                borderBottom: '1px dotted #eee' 
            })
        };
        return (
            <div>
                <div className={this.state.leftSideClassName}>
                    <div className="col-sm-12">
                        <span style={{ marginTop: 10, fontSize: 18 }}>Filter</span>
                    </div>
                    <div className="col-sm-12">
                        Hotel Name <br />
                        <div style={{border: "1px solid #eee", borderRadius: 5, marginBottom: 5, paddingBottom: 4}}>
                        <AsyncSelect
                            styles={customStyles}
                            className={`syncSelect`}
                            value={this.state.selectValue}
                            onChange={this.onChange}
                            loadOptions={loadOptions}
                            placeholder='Search Hotel Name'
                        />
                        </div>
                        
                    </div>
                    <div className="col-sm-12" style={{ marginTop: 20 }}>
                        Price Rage <br />
                        <div>
                            <div className="col-md-6" style={{ padding: 0 }}>
                                Min : <input
                                    key={`min-${this.state.versi}`}
                                    type='number'
                                    className="form-control"
                                    defaultValue={this.state.minPrice && !isNaN(this.state.minPrice) ? this.state.minPrice + '' : '0'}
                                    onBlur={trigerMin}
                                    onKeyDown={
                                        evt => {
                                            if (evt.keyCode === 13) {
                                                trigerMin(evt);
                                            }
                                        }
                                    }
                                />
                            </div>
                            <div className="col-md-6" style={{ padding: 0 }}>
                                Max : <input
                                    key={`max-${this.state.versi}`}
                                    type='number'
                                    className="form-control"
                                    defaultValue={this.state.maxPrice && !isNaN(this.state.maxPrice) ? this.state.maxPrice + '' : '0'}
                                    onBlur={trigetMax}
                                    onKeyDown={
                                        evt => {
                                            if (evt.keyCode === 13) {
                                                trigetMax(evt);
                                            }
                                        }
                                    }
                                />
                            </div>
                            <div className="col-md-12" style={{ padding: '20px 0' }} key={`rage-${this.state.versi}`}>
                                <Range
                                    min={isNull(this.state.minRate) ? 0 : this.state.minRate - 1}
                                    max={isNull(this.state.maxRate) ? 100 : this.state.maxRate + 1}
                                    tipFormatter={(value: any) => `${value}`}
                                    handle={handle}
                                    defaultValue={[isNull(this.state.minPrice) ? 0 : this.state.minPrice - 1, isNull(this.state.maxPrice) ? 100 : this.state.maxPrice + 1]}
                                    onAfterChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                    <ul className="map-left-panel-list">
                        {leftDataRan}
                    </ul>
                </div>
                <div className={this.state.leftsidegmapmenu}><i className='ti-menu' onClick={this.onLeftMenuClick} /></div>
                <div id={this.gmapDivId} style={style} />

            </div>
        );
    }

    renderGMAP(elementId: string) {
        let mpOpt: google.maps.MapOptions = this.generateMapOption();
        let targetDiv: HTMLElement | any = document.getElementById(this.gmapDivId);
        this.gmapReference = new google.maps.Map(targetDiv, mpOpt);
        this.onMapRendered(this.gmapReference);
    }

    /**
     *
     * @param map handler kalau map sudah di render. misal untuk render marker
     */
    abstract onMapRendered(map: google.maps.Map): any;

    /**
     * worker untuk generate map option
     */
    abstract generateMapOption(): google.maps.MapOptions;
    registerGmapScript() {
        if (this.mapStateManager.mapReady) {
            return;
        }
        window[this.mapReadyMethodName] = () => {
            this.mapStateManager.onMapReady();
        };
        var script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&callback=${this.mapReadyMethodName}`;
        script.setAttribute('defer', '');
        script.setAttribute('async', '');
        document.getElementsByTagName('head')[0].appendChild(script);
    }
}



// WEBPACK FOOTER //
// ./src/base/BaseGmapPanel.tsx